import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useSendSelfReferralMutation } from 'store/api/referral';
import { newToast } from 'store/slices/uiSlice';

export const useSelfReferral = () => {
  const dispatch = useDispatch();
  const [sendSelfReferral, { isLoading: isSendingSelfReferral }] =
    useSendSelfReferralMutation();

  const handleSelfReferral = useCallback(
    async (email: string, phone: string) => {
      const res = await sendSelfReferral({ email, phone });
      if ('error' in res) {
        dispatch(
          newToast({
            title: 'Error',
            description: 'Failed to send self-referral invitation.',
          }),
        );
        return false;
      }
      dispatch(
        newToast({
          title: 'Invitation Sent',
          description:
            'Check your personal email for a link to set up your account.',
        }),
      );
      return true;
    },
    [sendSelfReferral, dispatch],
  );

  return { handleSelfReferral, isSendingSelfReferral };
};
